function extractStringNodes (children) {
  var childList = [];
  children.forEach(function (child) {
    var prevChild = childList[childList.length - 1];
    if (typeof child === 'string' && typeof prevChild === 'string') {
      childList[childList.length - 1] += child;
    } else {
      childList.push(child);
    }
  });
  return childList;
}

export default extractStringNodes;
//# sourceMappingURL=extract-string-nodes.esm.js.map
